/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The page the manual verification request was submitted from.
 * @export
 */
export const VerificationRequestSource = {
    LegalEntityDetails: 'LEGAL_ENTITY_DETAILS',
    Payment: 'PAYMENT',
    AccountUpgrade: 'ACCOUNT_UPGRADE'
} as const;
export type VerificationRequestSource = typeof VerificationRequestSource[keyof typeof VerificationRequestSource];


export function instanceOfVerificationRequestSource(value: any): boolean {
    for (const key in VerificationRequestSource) {
        if (Object.prototype.hasOwnProperty.call(VerificationRequestSource, key)) {
            // @ts-ignore
            if (VerificationRequestSource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VerificationRequestSourceFromJSON(json: any): VerificationRequestSource {
    return VerificationRequestSourceFromJSONTyped(json, false);
}

export function VerificationRequestSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerificationRequestSource {
    return json as VerificationRequestSource;
}

export function VerificationRequestSourceToJSON(value?: VerificationRequestSource | null): any {
    return value as any;
}

